module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3ffcb2133b49c751d064019f2ed071ed.png";